import type { Store } from 'effector'
import type { UiCategoryWithVods } from '~/shared/interfaces'

import { api } from '@setplex/tria-api'
import { combine, createEvent, restore, sample } from 'effector'
import { not } from 'patronum'
import { model as i18n } from '~/core/i18n'
import { register } from '~/core/repository'
import { model as allCategory } from '~/entities/movies/all-category'
import { formatCategoryWithVodsToUi } from '~/entities/movies/lib'
import { ssePurchasesModel } from '~/features/payment/sse-purchases'
import { genPagesLogic } from '~/shared/effector'
import { F, nay, T } from '~/shared/helpers'

export const initCategoryPage = createEvent<{
  categoryId: number
}>()

export const left = createEvent()

export const initSubCategoryPage = createEvent<{
  categoryId: number
  subCategoryId: number
}>()

/** Skeleton start*/
export const setContentLoading = createEvent<boolean>()

export const $contentLoading = restore(setContentLoading, false)
/** Skeleton end*/

export const loadMoreVodsCategoryFormatted = genPagesLogic(
  api.vods.$vodsCategoryPageInfo,
  api.vods.loadVodsFx
)

sample({
  clock: initSubCategoryPage,
  fn: (clockData) => ({ categoryId: clockData.subCategoryId }),
  target: initCategoryPage,
})

sample({
  clock: initSubCategoryPage,
  filter: not(api.vods.initVodsCategoryFx.pending),
  fn: (clockData) => ({
    categoryId: Number(clockData.subCategoryId || clockData.categoryId),
  }),
  target: api.vods.initVodsCategoryFx,
})

export const $vodsSubCategoryFormatted: Store<UiCategoryWithVods | null> =
  combine(
    api.vods.$vodsCategory,
    ssePurchasesModel.$vod,
    i18n.$t,
    (category, adjust, { t }) => formatCategoryWithVodsToUi(category, adjust, t)
  )

/********** Skeleton logics starts ***********/

sample({
  clock: initSubCategoryPage,
  fn: T,
  target: setContentLoading,
})

sample({
  clock: api.vods.initVodsCategoryFx.fail,
  fn: F,
  target: setContentLoading,
})

sample({
  clock: api.vods.loadVodsFx.pending,
  filter: nay,
  target: setContentLoading,
})

/********** Skeleton logics ends ***********/

// clear paginatable stores
api.vods.$vodsCategory.reset(initSubCategoryPage)

register($vodsSubCategoryFormatted, '$vodsSubCategory')
register(loadMoreVodsCategoryFormatted, 'loadMoreVodsCategoryFormatted')
register(
  allCategory.$infiniteVodsTitle,
  '$movies/subcategory/infiniteVodsTitle'
)
